import { Badge, Table } from "flowbite-react";

const TabelaProdutos = ({ produtos, onProdutoClick, mostrarStatus = false }) => {
  return (
    <Table
      hoverable
      className="w-full text-left bg-white rounded-lg shadow-md select-none focus:outline-none"
    >
      <Table.Head>
        <Table.HeadCell className=" px-2 py-4">Referência</Table.HeadCell>
        <Table.HeadCell className=" px-2 py-4">Descrição</Table.HeadCell>
        <Table.HeadCell className=" px-2 py-4">Marca</Table.HeadCell>
        <Table.HeadCell className=" px-2 py-4">Fotos</Table.HeadCell>
      </Table.Head>
      <Table.Body className="divide-y">
        {produtos.length > 0 ? (
          produtos.map((produto) => (
            <Table.Row
              key={produto.id}
              onClick={() => onProdutoClick(produto)}
              className={`cursor-pointer ${
                produto.ativo === false ? "bg-gray-50 text-gray-500" : ""
              }`}
            >
              <Table.Cell className="px-2 py-3">
                {produto.referencia}
              </Table.Cell>
              <Table.Cell className="px-2 py-3 text-xs">
                <div className="flex flex-wrap items-center gap-2">
                  <span>{produto.descricao}</span>
                  {mostrarStatus && produto.ativo === false && (
                    <Badge color="gray" size="sm">
                      Inativo
                    </Badge>
                  )}
                </div>
              </Table.Cell>
              <Table.Cell className="px-2 py-3">{produto.marca}</Table.Cell>
              <Table.Cell className="px-2 py-3">
                <div className="flex items-center gap-2">
                  <div className="flex -space-x-2">
                    {(produto.fotos || []).slice(0, 3).map((foto) => (
                      <img
                        key={foto.id}
                        src={`${process.env.REACT_APP_UPLOADS_URL}${foto.url}`}
                        alt={produto.descricao}
                        className="w-9 h-9 rounded-md object-cover border border-white bg-gray-100"
                        loading="lazy"
                        decoding="async"
                      />
                    ))}
                    {(produto.fotos?.length || 0) === 0 && (
                      <div className="w-9 h-9 rounded-md border border-gray-200 bg-gray-100" />
                    )}
                  </div>
                  <span className="text-sm text-gray-600 whitespace-nowrap">
                    {produto.fotos?.length ?? 0} foto(s)
                  </span>
                </div>
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row>
            <Table.Cell colSpan="4" className="text-center text-gray-500">
              Nenhum produto encontrado.
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
};

export default TabelaProdutos;
